<nb-card>
  <nb-card-body class="p-0" style="min-height: 40px; overflow: hidden">
    <app-user-note-alert title="Note:">
      Create service account
      <a
        class="selected-text"
        href="https://cloud.google.com/iam/docs/creating-managing-service-account-keys"
        target="_blank"
      >
        here
      </a>
      with Owner permissions in the GCP project and create a new key for the
      service account and paste the contents below.
    </app-user-note-alert>
    <form tabindex="0" [formGroup]="gcpAccountForm" class="row mt-2">
      <div class="col-xl-12 col-md-12 col-xs-12 mt-3">
        <app-reactive-form-field
          label="Name"
          [required]="true"
          [showInfoAsTooltip]="false"
          labelSize="5"
          fieldId="name"
          fieldName="name"
          inputSize="7"
          placeholder="Enter unique name for the account"
          [customFormControl]="name"
          missingMsg="Name is required!"
          invalidPatternMsg="GCP account name should be a lowercase alphanumeric string and can only have hyphens"
        ></app-reactive-form-field>
      </div>
      <div class="col-xl-12 col-md-12 col-xs-12 mt-3">
        <app-reactive-text-area
          label="Service account key"
          [required]="true"
          [showInfoAsTooltip]="false"
          labelSize="5"
          fieldId="serviceKey"
          fieldName="serviceKey"
          inputSize="7"
          placeholder="Enter Service account key"
          [customFormControl]="serviceKey"
          missingMsg="Service account key is required!"
          invalidPatternMsg="Service account key is invalid!"
          [tooltipText]="'Service account key'"
        ></app-reactive-text-area>
      </div>
      <div class="col-xl-12 col-md-12 col-xs-12 mt-3">
        <app-reactive-form-field
          label="Project ID"
          [required]="true"
          [showInfoAsTooltip]="false"
          labelSize="5"
          fieldId="projectId"
          fieldName="projectId"
          inputSize="7"
          placeholder="Enter Project ID"
          [customFormControl]="projectId"
          missingMsg="Project ID is required!"
          invalidPatternMsg="Project ID is invalid!"
          [tooltipText]="'Project used for Facets.'"
        ></app-reactive-form-field>
      </div>
    </form>
  </nb-card-body>
  <nb-card-footer class="p-0 pt-3">
    <app-rbac-button
      [label]="mode === 'create' ? 'Create' : 'Update'"
      class="mr-3"
      status="primary"
      [action]="ACCOUNTS_WRITE"
      [loading]="saveAccountInProgress"
      [disabled]="gcpAccountForm.invalid || saveAccountInProgress"
      (onClick)="createEditGcpAccount()"
    ></app-rbac-button>
    <app-rbac-button
      [label]="'Verify Account'"
      class="mr-3"
      status="primary"
      [action]=""
      [loading]="verifyInProgress"
      [disabled]="gcpAccountForm.invalid || verifyInProgress"
      (onClick)="verifyAccount()"
      appearance="outline"
    ></app-rbac-button>
    <button
      nbButton
      size="small"
      class="mr-3"
      (click)="onClickHandleCancel(passedRef)"
    >
      Cancel
    </button>
  </nb-card-footer>
</nb-card>
